import React from 'react';
import PlatformConnections from '@/components/PlatformConnections';

export default function Platforms() {
	return (
		<div className='container mx-auto py-8'>
			<div className='space-y-8'>
				<div>
					<h1 className='text-3xl font-bold tracking-tight'>
						Platform Management
					</h1>
					<p className='text-muted-foreground mt-2'>
						Connect and manage your streaming platforms
					</p>
				</div>

				<PlatformConnections />
			</div>
		</div>
	);
}
